import { Typography, styled } from "@mui/material"

export const SecurityLabel = styled(Typography)(({ theme }) => ({
  fontSize: theme.typography.pxToRem(16),
  color: theme.palette.grey.dark,
  textAlign: "center",
}))
